exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-investors-allocate-___style__header___CrYLH{display:flex;justify-content:space-between}.web-flows-deal-investors-allocate-___style__h2____vm5t{width:100%}.web-flows-deal-investors-allocate-___style__table___3cnZo{display:flex;flex-flow:column nowrap;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"header": "web-flows-deal-investors-allocate-___style__header___CrYLH",
	"h2": "web-flows-deal-investors-allocate-___style__h2____vm5t",
	"table": "web-flows-deal-investors-allocate-___style__table___3cnZo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/investors/allocate/style.css
// module id = 1340
// module chunks = 0